import { DASHBOARD_FILTER_DETAILS_REQUEST,
        DASHBOARD_FILTER_DETAILS_SUCCESS,
        DASHBOARD_FILTER_DETAILS_ERROR,
        SET_SCENARIO_GROUP_AND_BENCH_NAME_REQUEST,
        SET_SCENARIO_GROUP_AND_BENCH_NAME_ERROR,
        SET_TAG_NAME_ARRANGE_SCENARIO_GROUP_IDS,
        SET_SCENARIO_GROUP_ID_ARRANGE_BENCH_NAMES,
        SET_SCENARIO_GROUP_NAME_ARRANGE_BENCH_NAMES,
	SET_SCENARIO_GROUP_NAME_WITH_ID_ARRANGE_BENCH_NAMES,
        SET_BENCH_NAME_ARRANGE_RUN_IDS,
        SET_RUN_ID_ARRANGE_SCENARIO_UUIDS_REQUEST,
        SET_RUN_ID_ARRANGE_SCENARIO_UUIDS,
        SET_RUN_ID_ARRANGE_SCENARIO_UUIDS_ERROR,
        SET_SCENARIO_UUID_AND_DESCRIPTION,
        SET_FORM_FILTER_DATA_RESET } from './../../../constants/closeLoop/kpiDashboard/dashboardConstants';

const INITIAL_STATE = {
    loading: false,
    error: '',
    info: {
        tagRecords: [],
        records: [],
        scenarioInfo: {
            loading: false,
            error: '',
            scenarioRecords: []
        },
        selectData: {
            tagName: '',
            benchName: '',
            scenarioGroupId: '',
            scenarioGroupName: '',
	    scenarioGroupNameWithId: '',
            runId: '',
            scenarioId: '',
            description: '',
            scenarioFileName: ''
        },
        tagNames: [],
        benchNames: [],
        scenarioGroupIds: [],
        scenarioGroupNames: [],
	scenarioGroupNamesWithId: [],
        runIds: [],
        scenarioIds: []
    }
};

export const dashboardFilterDataReducer = (state=INITIAL_STATE, action) => {
    switch(action.type) {
        case DASHBOARD_FILTER_DETAILS_REQUEST:
            return {
                ...state,
                loading: true,
                error: '',
            }

        case DASHBOARD_FILTER_DETAILS_SUCCESS:
            const { message, records, tag_names } = action.payload;
            console.log(message)
            const uniqueTagNames = [...new Set(tag_names)];

            return {
                ...state,
                loading: false,
                error: '',
                info: {
                    ...state.info,
                    tagNames: uniqueTagNames.map((item, index) => {
                        return {label:item, value:index}
                    }),
                    tagRecords: records
                }
            }

        case DASHBOARD_FILTER_DETAILS_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload
            }

        case SET_SCENARIO_GROUP_AND_BENCH_NAME_REQUEST:
            return {
                ...state,
                info: {
                    ...state.info,
                    scenarioInfo: {
                        loading: true,
                        error: ''
                    }
                }
            }


        case SET_TAG_NAME_ARRANGE_SCENARIO_GROUP_IDS:
            const scenarioGroupIds = [...new Set(action.payload.records.filter((item) =>
                item['tag_name'] === action.tagName).map((item) =>
                item['scenario_group_id']))];
            const scenarioGroupNames = [...new Set(action.payload.records.filter((item) =>
                item['tag_name'] === action.tagName).map((item) =>
                item['scenario_group_name']))];
	    const scenarioGroupNamesWithIds = [...new Set(action.payload.records.filter((item) =>
                item['tag_name'] === action.tagName).map((item) =>
                `${item['scenario_group_name']}---${item['scenario_group_id']}`))];
            return {
                ...state,
                info: {
                    ...state.info,
                    scenarioInfo: {
                        loading: false,
                        error: ''
                    },
                    selectData: {
                        ...state.info.selectData,
                        tagName: action.tagName
                    },
                    scenarioGroupIds: scenarioGroupIds.map((item, index) => {
                        return {label: item, value: index}
                    }),
                    scenarioGroupNames: scenarioGroupNames.map((item, index) => {
                        return {label: item, value: index}
                    }),
		    scenarioGroupNamesWithId: scenarioGroupNamesWithIds.map((item, index) => {
			return {label: item, value: index}
		    }),
                    records: action.payload['records'],
                    benchNames: [],
                    runIds: [],
                    scenarioIds: []
                }
            }

	case SET_SCENARIO_GROUP_NAME_WITH_ID_ARRANGE_BENCH_NAMES:
	    let [scenarioGroupName, scenarioGroupId] = action.payload.split('---');
	    if (typeof(scenarioGroupId) === 'string') {
                scenarioGroupId = Number(scenarioGroupId);
	    }
	    const benchDetails = [...new Set(state.info.records.filter((item) => 
	        item['tag_name'] === state.info.selectData.tagName 
	        && item['scenario_group_id'] === scenarioGroupId).map((item) => 
		item['bench_name'] ))];
	    return {
		...state,
		info: {
	            ...state.info,
		    scenarioInfo: {
	                loading: false,
			error: ''
		    },
	            selectData: {
			...state.info.selectData,
			scenarioGroupName,
			scenarioGroupId,
		    },
	            benchNames: benchDetails.map((item, index) => {
		        return {label: item, value: index}
		    }),
	            runIds: [],
		    scenarioIds: []
		}
	    }

        case SET_SCENARIO_GROUP_AND_BENCH_NAME_ERROR:
            return {
                ...state,
                info: {
                    ...state.info,
                    scenarioInfo: {
                        loading: false,
                        error: action.payload
                    },
                }
            }

        case SET_SCENARIO_GROUP_ID_ARRANGE_BENCH_NAMES:
            const benchNames = [...new Set(state.info.records.filter((item) =>
                item['tag_name'] === state.info.selectData.tagName
                && item['scenario_group_id'] === action.payload).map((item) =>
                item['bench_name'] ))];
            return {
                ...state,
                info: {
                    ...state.info,
                    selectData: {
                        ...state.info.selectData,
                        scenarioGroupId: action.payload
                    },
                    benchNames: benchNames.map((item, index) => {
                        return {label: item, value: index}
                    }),
                    runIds: [],
                    scenarioIds: []
                }
            }

        case SET_SCENARIO_GROUP_NAME_ARRANGE_BENCH_NAMES:
            const benches = [...new Set(state.info.records.filter((item) =>
                item['tag_name'] === state.info.selectData.tagName
                && item['scenario_group_name'] === action.payload).map((item) =>
                item['bench_name'] ))];
            return {
                ...state,
                info: {
                    ...state.info,
                    selectData: {
                        ...state.info.selectData,
                        scenarioGroupName: action.payload
                    },
                    benchNames: benches.map((item, index) => {
                        return {label: item, value: index}
                    }),
                    runIds: [],
                    scenarioIds: []
                }
            }

        case SET_BENCH_NAME_ARRANGE_RUN_IDS:
            const testRuns = [...new Set(state.info.records.filter((item) =>
                item['tag_name'] === state.info.selectData.tagName
                && (item['scenario_group_id'] === state.info.selectData.scenarioGroupId ||
                item['scenario_group_name'] === state.info.selectData.scenarioGroupName)
                && item['bench_name'] === action.payload
            ).map((item) => item['test_run_id']))];
            return {
                ...state,
                info: {
                    ...state.info,
                    selectData: {
                        ...state.info.selectData,
                        benchName: action.payload,
                    },
                    runIds: testRuns.map((item, index) => {
                        return {label: item, value: index}
                    }),
                    scenarioIds: []
                },
            }

        case SET_RUN_ID_ARRANGE_SCENARIO_UUIDS_REQUEST:
            return {
                ...state,
                info: {
                    ...state.info,
                    scenarioInfo: {
                        loading: true,
                        error: '',
                        scenarioRecords: []
                    },
                    selectData: {
                        ...state.info.selectData,
                        runId: action.runId
                    },
                    scenarioIds: []
                }
            }

        case SET_RUN_ID_ARRANGE_SCENARIO_UUIDS:
            return {
                ...state,
                info: {
                    ...state.info,
                    scenarioInfo: {
                        loading: false,
                        error: '',
                        scenarioRecords: action.payload
                    },
                    selectData: {
                        ...state.info.selectData,
                        runId: action.runId,
                    },
                    scenarioIds: action.payload.map((item, index) => {
                        return {label: item['scenario_file_name'], value: index}
                    })
                },
            }

        case SET_RUN_ID_ARRANGE_SCENARIO_UUIDS_ERROR:
            return {
                ...state,
                info: {
                    ...state.info,
                    scenarioInfo: {
                        loading: false,
                        error: action.payload,
                        scenarioRecords: []
                    },
                    selectData: {
                        ...state.info.selectData,
                        runId: action.runId,
                    },
                    scenarioIds: []
                }
            }

        case SET_SCENARIO_UUID_AND_DESCRIPTION:
            const { scenarioRecords } = state.info.scenarioInfo;
            const sceneInfo = scenarioRecords.find((item) =>
                item['scenario_file_name'] === action.payload);
            return {
                ...state,
                info: {
                    ...state.info,
                    scenarioInfo: {
                        ...state.info.scenarioInfo
                    },
                    selectData: {
                        ...state.info.selectData,
                        scenarioId: sceneInfo.scenario_uuid,
                        description: sceneInfo.description,
                        scenarioFileName: sceneInfo.scenario_file_name
                    }
                }
            }

        case SET_FORM_FILTER_DATA_RESET:
            return {
                ...state,
                info: {
                    ...state.info,
                    selectData: {
                        ...state.info.selectData,
                        benchName: '',
                        scenarioGroupId: '',
                        scenarioGroupName: '',
                        runId: '',
                        scenarioId: '',
                        description: '',
                        scenarioFileName: ''
                    }
                }
            }

        default:
            return state;
    }
}
